<template>
  <div>
    <v-container class="py-10 py-md-13 py-lg-16">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="7">
          <TitleWidget class="text-center text-sm-left"
            >Fale Conosco</TitleWidget
          >

          <div
            class="
              grey--text
              text--darken-1 text-body-2 text-center text-sm-left
              mt-12
              item-subtitle
            "
          >
            Preencha os dados abaixo e nos envie uma mensagem
          </div>

          <ContactForm
            class="mt-6"
            :action="files + formAction"
            response-to="/fale-conosco/obrigado"
          />
        </v-col>
      </v-row>
    </v-container>

    <div v-if="informations.map" class="map" v-html="informations.map"></div>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ContactForm from "../components/forms/ContactForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>

<style lang="scss" scoped>
.map::v-deep {
  aspect-ratio: 1920 / 500;
  min-height: 400px;
  -o-object-fit: cover;
  object-fit: cover;

  iframe {
    height: 100% !important;
    width: 100% !important;
  }
}
</style>
